import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "private-address-addition" }
const _hoisted_2 = ["aria-expanded"]
const _hoisted_3 = {
  id: "privateAddressAddition",
  "aria-labelledby": "privateAddressAdditionCTA",
  class: "form-row"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IconTilde = _resolveComponent("IconTilde")!
  const _component_FormElementInputField = _resolveComponent("FormElementInputField")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      id: "privateAddressAdditionCTA",
      class: _normalizeClass(["link mb-1 accordion", _ctx.additionalInfoSelected ? 'active' : '']),
      type: "button",
      onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.additionalInfoSelected = !_ctx.additionalInfoSelected), ["prevent"])),
      "aria-expanded": _ctx.additionalInfoSelected,
      "aria-controls": "privateAddressAddition"
    }, [
      _createVNode(_component_IconTilde, { active: _ctx.additionalInfoSelected }, null, 8, ["active"]),
      _createTextVNode(" " + _toDisplayString(_ctx.commonTexts.userInterface.formFieldLabels.showAddressAdditionFormPrivate), 1)
    ], 10, _hoisted_2),
    _withDirectives(_createElementVNode("div", _hoisted_3, [
      _createVNode(_component_FormElementInputField, {
        label: _ctx.commonTexts.userInterface.formFieldLabels.addressAddition,
        "field-id": 
          _ctx.commonTexts.userInterface.formFieldLabels.addressAddition +
          _ctx.fieldIdSlug
        ,
        value: _ctx.value.addressAddition,
        onInput: _cache[1] || (_cache[1] = ($event: any) => (_ctx.update(_ctx.formFields.ADDRESS_ADDITION, $event))),
        "field-has-error": _ctx.fieldErrors.addressAddition,
        "field-is-required": false,
        class: "col-md-12 mb-4",
        maxlength: "35"
      }, null, 8, ["label", "field-id", "value", "field-has-error"]),
      _createVNode(_component_FormElementInputField, {
        label: _ctx.commonTexts.userInterface.formFieldLabels.floor,
        "field-id": 
          _ctx.commonTexts.userInterface.formFieldLabels.floor + _ctx.fieldIdSlug
        ,
        value: _ctx.value.floor,
        onInput: _cache[2] || (_cache[2] = ($event: any) => (_ctx.update(_ctx.formFields.FLOOR, $event))),
        "field-has-error": _ctx.fieldErrors.floor,
        "field-is-required": false,
        class: "col-md-6 mb-4",
        maxlength: "6"
      }, null, 8, ["label", "field-id", "value", "field-has-error"]),
      _createVNode(_component_FormElementInputField, {
        label: _ctx.commonTexts.userInterface.formFieldLabels.room,
        "field-id": _ctx.commonTexts.userInterface.formFieldLabels.room + _ctx.fieldIdSlug,
        value: _ctx.value.room,
        onInput: _cache[3] || (_cache[3] = ($event: any) => (_ctx.update(_ctx.formFields.ROOM, $event))),
        "field-has-error": _ctx.fieldErrors.room,
        "field-is-required": false,
        class: "col-md-6 mb-4"
      }, null, 8, ["label", "field-id", "value", "field-has-error"]),
      _createVNode(_component_FormElementInputField, {
        label: _ctx.commonTexts.userInterface.formFieldLabels.additionalInfoPrivate,
        "field-id": 
          _ctx.commonTexts.userInterface.formFieldLabels.additionalInfoPrivate +
          _ctx.fieldIdSlug
        ,
        value: _ctx.value.additionalInfo,
        onInput: _cache[4] || (_cache[4] = ($event: any) => (_ctx.update(_ctx.formFields.ADDITIONAL_INFO, $event))),
        "field-has-error": _ctx.fieldErrors.additionalInfo,
        "field-is-required": false,
        class: "col-md-12 mb-4",
        maxlength: "50"
      }, null, 8, ["label", "field-id", "value", "field-has-error"])
    ], 512), [
      [_vShow, _ctx.additionalInfoSelected]
    ])
  ]))
}